import { useState, useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { Toaster } from "react-hot-toast";

import { MdArrowForwardIos } from 'react-icons/md';
import { HiMagnifyingGlass } from 'react-icons/hi2';
import { AiOutlineClose } from 'react-icons/ai';
import { GoPlus } from 'react-icons/go';

import { useClientsActions } from '../../../services/actions/clients.actions';
import { clientsAtom } from '../../../services/atoms/clients.atoms';

import { TopInfo } from "../../components/top-info/top-info";
import { InputIcon } from '../../../components/inputs/input-icon';
import { ROUTES } from '../../../helpers/constants';
import TableComponent from '../../../components/table/table-component';
import CreateClientModal from './components/create-modal';
import { userAtom } from '../../../services/atoms/auth.atoms';

const topInfo = { title: 'Listado Clientes', subtitle: 'Registro de clientes empresa' };

const columns = [
  { Header: 'RUT', accessor: 'rut' },
  { Header: 'Nombre Empresa', accessor: 'name' },
  { Header: 'Rubro', accessor: 'sector', disableFilters: true },
  { Header: 'Encargado', accessor: 'responsibleName', disableFilters: true },
  { Header: ' ', accessor: '', disableFilters: true, disableSortBy: true, type: 'actions' },
];

const initialSearchValue = { name: '', sector: '' };

const Clients = () => {
  let navigate = useNavigate();
  const { clientsList } = useClientsActions();
  const clients = useRecoilValue(clientsAtom);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);
  const user = useRecoilValue(userAtom);

  const isInitialMount = useRef(true);

  useEffect(() => {
    clientsList({ page, limit });
    // eslint-disable-next-line
  }, [page, limit]);

  useEffect(() => {
    if (!clients?.loading && clients?.payload.length !== 0) {
      const clientLogged = clients?.payload?.filter(
        (clients) => clients.id === user?.data?.clientId
      );
      if (user?.data?.isAdmin || user?.data?.isAdminBasic) {
        navigate(`${ROUTES.CLIENTS.route}/${user?.data.clientId}`, {
          state: { client: clientLogged[0] },
        });
      }
    }
    //eslint-disable-next-line
  }, [clients.loading]);
  const handleOpenModal = () => setOpen(!open);
  const handleChangePage = (e) => setPage(e + 1);
  const handleSetLimit = (e) => setLimit(e);
  const handleOpenDetails = (e, index) =>
    navigate(`${ROUTES.CLIENTS.route}/${e.id}`, {
      state: { client: e, index: `${index}` },
    });

  const handleChangeValue = (key, value) =>
    setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSubmit = (e, key) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let form = Object.fromEntries(data.entries());
    let search = { column: key, value: form["search"] };
    setSearch(form["search"]);
    clientsList({ page, limit, search });
  };

  const handleCleanSearch = () => {
    setSearch("");
    setSearchValue(initialSearchValue);
    clientsList({ page, limit });
  };

  const actions = [{ icon: MdArrowForwardIos, action: handleOpenDetails }];

  return (
    <div className="gm-clients-screen-container">
      {user?.data?.isSuperAdmin ? (
        <>
          <Toaster />
          <CreateClientModal
            open={open}
            toggle={handleOpenModal}
            pageHandler={{ page, limit }}
            isCreate={true}
            dataCheck={clients?.payload || []}
          />
          <TopInfo info={topInfo} />
          <div className="gm-search-banner-container">
            <div className="gm-search-forms-container">
              <form onSubmit={(e) => handleSubmit(e, "name")}>
                <InputIcon
                  Icon={HiMagnifyingGlass}
                  type="text"
                  placeholder="Buscar por nombre"
                  name="search"
                  value={searchValues.name}
                  onChange={(e) => handleChangeValue("name", e.target.value)}
                />
              </form>
              <form onSubmit={(e) => handleSubmit(e, "sector")}>
                <InputIcon
                  Icon={HiMagnifyingGlass}
                  type="text"
                  placeholder="Buscar por rubro"
                  name="search"
                  value={searchValues.sector}
                  onChange={(e) => handleChangeValue("sector", e.target.value)}
                />
              </form>
              {searchExists && (
                <button
                  className="gm-clean-search-button"
                  onClick={handleCleanSearch}
                  type="button"
                >
                  <AiOutlineClose size={18} />
                </button>
              )}
            </div>
            <button
              type="button"
              className="gm-primary-button gm-banner-button"
              onClick={handleOpenModal}
            >
              Crear
              <GoPlus size={18} />
            </button>
          </div>
          <TableComponent
            data={clients?.payload || []}
            loading={clients.loading}
            columns={columns}
            handleOpenDetails={handleOpenDetails}
            handleChangePage={handleChangePage}
            handleSetLimit={handleSetLimit}
            controlledPageCount={
              clients.total ? Math.ceil(clients.total / limit) : 1
            }
            actions={actions}
            section={{ plural: "clientes", singular: "cliente" }}
            manualPagination={true}
            pagination
          />
        </>
      ) : (
        <div className="gm-clients-screen-container">
          <TableComponent
            data={[]}
            loading={clients.loading}
            columns={columns}
            handleOpenDetails={handleOpenDetails}
            handleChangePage={handleChangePage}
            handleSetLimit={handleSetLimit}
            controlledPageCount={
              clients.total ? Math.ceil(clients.total / limit) : 1
            }
            actions={actions}
            section={{ plural: "clientes", singular: "cliente" }}
          />
        </div>

      )}
    </div>
  );
}

export default Clients;
